export const RETURN_TO_KEY = 'recepthor.returnTo';
const MAX_AGE = 15 * 60 * 1000;

export function hasPendingReturnTo() {
  try {
    return Boolean(sessionStorage.getItem(RETURN_TO_KEY));
  } catch {
    return false;
  }
}

export function isInternalRoute(path) {
  return (
    typeof path === 'string' &&
    path.startsWith('/') &&
    !path.startsWith('//') &&
    !path.includes('\\') &&
    !Array.from(path).some(
      (char) => char.charCodeAt(0) <= 32 || char.charCodeAt(0) === 127,
    ) &&
    path.split(/[?#]/)[0].replace(/\/+$/, '').toLowerCase() !== '/login'
  );
}

export function saveReturnTo(path) {
  if (!isInternalRoute(path)) return;
  try {
    sessionStorage.setItem(
      RETURN_TO_KEY,
      JSON.stringify({ path, timestamp: Date.now() }),
    );
  } catch {
    // Storage may be disabled; keep the existing login flow.
  }
}

export function consumeReturnTo() {
  try {
    const raw = sessionStorage.getItem(RETURN_TO_KEY);
    if (!raw) return null;
    sessionStorage.removeItem(RETURN_TO_KEY);
    const { path, timestamp } = JSON.parse(raw);
    const age = Date.now() - timestamp;
    return isInternalRoute(path) &&
      Number.isFinite(timestamp) &&
      age >= 0 &&
      age < MAX_AGE
      ? path
      : null;
  } catch {
    return null;
  }
}
